import Link from "@mui/material/Link";

/**
 * A "skip to main content" link: the first thing a keyboard user tabs to, so they can bypass
 * the header and navigation on every page. Invisible until it has focus.
 */
export default function SkipLink({ targetId = "main" }: { targetId?: string }) {
  return (
    <Link
      href={`#${targetId}`}
      onClick={(event) => {
        // The router would otherwise treat the hash as a navigation and leave focus behind.
        event.preventDefault();
        const target = document.getElementById(targetId);
        if (target) {
          target.setAttribute("tabindex", "-1");
          target.focus();
          target.scrollIntoView();
        }
      }}
      sx={{
        position: "fixed",
        top: -100,
        left: 8,
        zIndex: 20000,
        bgcolor: "background.paper",
        color: "text.primary",
        px: 2,
        py: 1,
        borderRadius: 1,
        boxShadow: 3,
        fontWeight: 600,
        "&:focus": { top: 8 },
      }}
    >
      Skip to main content
    </Link>
  );
}
